import { Fragment, type ReactNode } from "react";

export function Viewport({
  desktop,
  mobile,
  breakpoint = "sm",
}: {
  breakpoint?: "sm" | "md";
  desktop: ReactNode;
  mobile: ReactNode;
}) {
  return (
    <Fragment>
      {breakpoint === "sm" ? (
        <>
          <div className="sm:hidden">{mobile}</div>
          <div className="hidden sm:block">{desktop}</div>
        </>
      ) : (
        <>
          <div className="md:hidden">{mobile}</div>
          <div className="hidden md:block">{desktop}</div>
        </>
      )}
    </Fragment>
  );
}
